import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AmbienteService } from '../multi-tenancy/ambiente.service';
import { NotificacaoDTO, NotificacaoOperacao } from './notificacao-dto.model';
import { Notificacao } from './notificacao.model';


@Injectable({
  providedIn: 'root'
})
export class NotificacaoService {

  private notificacaoSubject = new Subject<NotificacaoDTO>();
  private static arquivoLogoPequena = '';

  constructor(
    private ambienteService: AmbienteService
  ) { }

  carregarAmbiente(): void {
    const ambiente = this.ambienteService.getAmbiente();
    if ( ambiente ) {
      NotificacaoService.arquivoLogoPequena = ambiente.getArquivoLogoPequena();
    }    
  }

  getNotificacaoSubject(): Subject<NotificacaoDTO> {
    return this.notificacaoSubject;
  }

  adicionarNotificacao(o: Notificacao): void {
    if ( !o.getToken() ) {
      o.gerarTokenAutomatico();
    }

    this.notificacaoSubject.next({
      operacao: NotificacaoOperacao.ADICIONAR,
      notificacao: o
    });
  }

  removerNotificacaoPorToken(token: string): void {
    const o = new Notificacao();
    o.setToken(token);
    this.removerNotificacao(o);
  }

  removerNotificacao(o: Notificacao): void {
    this.notificacaoSubject.next({
      operacao: NotificacaoOperacao.REMOVER,
      notificacao: o
    });
  }

  limparNotificacao(): void {
    this.notificacaoSubject.next({
      operacao: NotificacaoOperacao.LIMPAR,
      notificacao: null
    });
  }

  static criarNotificacaoTexto(title: string) {
    this.criarNotificacao({
                            notification: {
                              title: title,
                              body: ''
                            }
                          });
  }

  static criarNotificacao(message: {notification}) {
    const title = message.notification.title;
    const body = message.notification.body;

    var n = new Notification(
      title, {
			  body: body,
			  icon: NotificacaoService.arquivoLogoPequena
		  })
  }

}
